import { render } from "./confirm-purchase.vue?vue&type=template&id=1378cf3a&scoped=true"
import script from "./confirm-purchase.vue?vue&type=script&lang=js"
export * from "./confirm-purchase.vue?vue&type=script&lang=js"

import "./confirm-purchase.vue?vue&type=style&index=0&id=1378cf3a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\tnism\\Documents\\Projects\\MiniApp\\miniapp_wing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1378cf3a"]])

export default __exports__